import { get, post } from "@/utils/request";
import type {  CommonForm, Detail } from "@/types/procss";
import type { Response } from "@/types/axios";

// 提交财务预算申请 
export const submitBudgetApply = (
  params: CommonForm
): Promise<Response<Detail>> =>
  post("/api/finance/submitBudgetApply", params);

// 获取财务预算申请详情
export const budgetDetail = (params: {
    Id: number | string;
    params: CommonForm
  }): Promise<Response<Detail>> =>
  post("/api/finance/budgetDetail", params);
// 更新财务预算申请
export const editBudgetApply = (
    params: CommonForm
  ): Promise<Response<Detail>> =>
    post("/api/finance/editBudgetApply", params);
// 撤回财务预算申请
export const recallBudgetApply = (
    params: CommonForm
  ): Promise<Response<Detail>> =>
    post("/api/finance/recallBudgetApply", params);
    
// 个人借款申请详情
export const borrowApplyDetail = (
    params: CommonForm
  ): Promise<Response<Detail>> =>
    post("/api/borrow/applyDetail", params);
// 提交个人借款申请
export const borrowSubmitApply = (
    params: CommonForm
  ): Promise<Response<Detail>> =>
    post("/api/borrow/submitApply", params);
    // 更新个人借款申请
export const borrowEditApply= (
    params: CommonForm
  ): Promise<Response<Detail>> =>
    post("/api/borrow/editApply", params);
    // 撤回个人借款申请
export const borrowRecallApply = (
    params: CommonForm
  ): Promise<Response<Detail>> =>
    post("/api/borrow/recallApply", params);